import React from 'react';

export default () => <div className="container-fluid">
    <h4>iFE health</h4>
</div>